module.exports = __webpack_public_path__ + "img/uga-app-logo.5f37eb87.png";